module.exports = __webpack_public_path__ + "img/30.d9a17329.jpg";